import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService, EventEmitterService, MatDialogUtilsService, UtilsService } from '../../../shared/services';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.less']
})
export class RedirectComponent implements OnInit {
    @Input() isHandset: boolean;
    @Input() isWishlisted;
    @Output() wishlist = new EventEmitter();
    showLogin = false;
    email = '';
    password = '';
    error;
    errorMsg = '';
    private attribute = {
        postGuestKey: 'guest',
        lsGuestUser: 'guest-user',
        lsGuestUserToken: 'guest-token',
        lsRegularUser: 'user',
        cookieUserRegularToken: 'token'
    };

    constructor(
        private matDialogUtils: MatDialogUtilsService,
        private cookie: CookieService,
        private snackbar: MatSnackBar,
        private apiService: ApiService,
        private utils: UtilsService,
        private eventService: EventEmitterService
    ) {
    }

    ngOnInit() {
    }

    openSignup() {
        this.matDialogUtils.openSignupDialog(this.isHandset, true);
    }

    enableLogin() {
        this.showLogin = true;
    }

    validateForm(email, password) {
        this.error = false;
        if (!email) {
            this.error = true;
            this.errorMsg = 'Email cannot be blank';
        }
        //  else if (!password) {
        //     this.error = true;
        //     this.errorMsg = 'Password cannot be blank';
        // } else if (password.length < 8) {
        //     this.error = true;
        //     this.errorMsg = 'Password must contain 8 characters';
        // }
        return !this.error;
    }

    handleError(payload: any) {
        this.error = true;
        this.errorMsg = payload.error;
    }

    checkEmail() {
        if (this.validateForm(this.email, this.password)) {

            this.apiService.getUserByMail(this.email).subscribe((res: any) => {
                if (res.status) {
                    // this.error = true;
                    // this.errorMsg = res.message;
                    this.snackbar.open(res.message, 'x', {
                        duration: 5000,
                    });
                    this.openSignInDialog();
                } else {
                    // this.openSignupDialog();
                    this.apiService.saveQuizMail({ email: this.email ,  name: ''}).subscribe(
                (payload: any) => {
                    if (payload.success) {
                        this.error = false;
                         localStorage.setItem("user", JSON.stringify(payload.user));
                        this.eventService.fetchUser(
                            payload.success.token,
                            payload.user
                        ); 
                            this.markWishlist();  
                    }
                },
                (error: any) => {
                    if (error.error.error.email) {
                        this.error = true;
                        this.errorMsg = error.error.error.email;
                        return false;
                    } else if (error.error.error) {
                        this.handleError(error.error);
                    }
                }
            );
                }
            }, err => {
                this.error = true;
                this.errorMsg = err.error && err.error.message ? err.error.message : 'Error occurred while checking email';
            });
        }
    }
    openSignInDialog() {
        this.matDialogUtils.openSigninDialog(this.isHandset ? "90%" : "35%").afterClosed().subscribe((res: any) => {
            if (!res) {
                this.markWishlist();
            }
        });
    }

    openSignupDialog() {
        this.matDialogUtils.openSignupDialog(this.isHandset, true).afterClosed().subscribe((res: any) => {
            if (!res) {
                this.markWishlist();
            }
        });
    }

    login() {
        if (this.validateForm(this.email, this.password)) {
            const formData: any = new FormData();
            formData.append('name', name);
            formData.append('email', this.email);
            formData.append('password', this.password);
            formData.append('c_password', this.password);
            this.apiService.signup(formData).subscribe(
                (payload: any) => {
                    if (payload.success) {
                        this.error = false;
                        this.eventService.fetchUser(
                            payload.success.token,
                            payload.success.user
                        );
                        this.markWishlist(); 
                    }
                },
                (error: any) => {
                    if (error.error.error.email) {
                        this.error = true;
                        this.errorMsg = error.error.error.email;
                        return false;
                    } else if (error.error.error) {
                        this.handleError(error.error);
                    }
                }
            );
        }
    }

    checkLogin() {
        const user: any = JSON.parse(localStorage.getItem('user'));
        console.log(user, user.authorization !== this.utils.userType.guest);
        if (user.authorization && user.authorization !== this.utils.userType.guest) {
            this.markWishlist();
        } else {
            this.enableLogin();
        }
    }

    markWishlist() {
        this.wishlist.emit(true);
    }
}
